import { ObjectValues } from 'types/common';

export const TAG_FORM_NAMES = {
  ClientTags: 'clientTags',
  MailCodeTags: 'mailCodeTags',
  PackageTags: 'packageTags',
} as const;

export type TagFormNames = ObjectValues<typeof TAG_FORM_NAMES>;
